import React, { useState } from "react";
import { Grid, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import GlobalDropdownField from "../utils/GlobalDropdownField";
import CustomInput from "../utils/Input";

const ProductPricingSection = ({
  categoryOptions,
  productTypeOptions,
  unitOptions,
  value,
  onChange,
  onCategoryChange,
}) => {
  const handleRowChange = (index, field, valueData) => {
    const updatedRows = [...value];

    updatedRows[index][field] = valueData;

    if (field === "category") {
      updatedRows[index].productType = "";
      if (onCategoryChange) {
        onCategoryChange(valueData);
      }
    }

    onChange(updatedRows);
  };

  const handleRemoveRow = (index) => {
    const rows = value.filter((_, i) => i !== index);
    onChange(rows);
  };

  return (
    <div className="p-4 bg-gray-100 rounded-lg">
      {value.map((row, index) => (
        <Grid container spacing={2} key={index} className="my-4">
          {/* CATEGORY */}
          <Grid item xs={12} md={3}>
            <GlobalDropdownField
              label="Category"
              value={row.category}
              options={categoryOptions}
              placeholder="Select Category"
              onChange={(e) =>
                handleRowChange(index, "category", e.target.value)
              }
            />
          </Grid>

          {/* PRODUCT TYPE */}
          <Grid item xs={12} md={3}>
            <GlobalDropdownField
              label="Product Type"
              value={row.productType}
              options={productTypeOptions[row.category] || []}
              placeholder="Select Product Type"
              onChange={(e) =>
                handleRowChange(index, "productType", e.target.value)
              }
            />
          </Grid>

          {/* UNIT */}
          <Grid item xs={12} md={3}>
            <GlobalDropdownField
              label="Unit of Measure"
              value={row.unit}
              options={unitOptions}
              placeholder="Select Unit"
              onChange={(e) => handleRowChange(index, "unit", e.target.value)}
            />
          </Grid>

          {/* RATE */}
          <Grid item xs={12} md={2}>
            <CustomInput
              title="Rate"
              type="number"
              size="small"
              value={row.rate}
              placeholder="Enter Rate"
              onChange={(e) => handleRowChange(index, "rate", e.target.value)}
            />
          </Grid>

          {/* DELETE */}
          <Grid
            item
            xs={12}
            md={1}
            className="flex justify-center items-center"
          >
            <IconButton color="error" onClick={() => handleRemoveRow(index)}>
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      ))}
    </div>
  );
};

export default ProductPricingSection;
